export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9913.dea6877a.jpg";